import { IBlueBenefitsSubscription } from "../../../../../blue-benefits/models/subscriptions/blue-benefits-subscription.interface";
import { DialogResult } from "../../../../../dialog/dialog-enums";
import { IDotRezPersonComment } from "../../../../../dot-rez-api/data-contracts/user/person.data-contracts";
import { CompanionModel } from "../../../companion/companion.model";
import { IPersonViewModel } from "../../../person/person-view-model.interface";
import {IAuthorizedUserProfileDomain} from "./authorized-user-profile-domain.interface";
import {AuthorizedUserProfileModel} from "../authorized-user-profile.model";
import {IServiceFactory} from "../../../../../service-factory.interface";
import {IDotRezUserAccountInfo} from "../../../../../dot-rez-api/data-contracts/user/user-data-contracts";
import {makeObservable, observable, runInAction} from "mobx";
import {Price} from "../../../../../currency/price";
import {HttpStatusCodeEnum} from "../../../../../../types/http-status-code.enum";
import {PsoTotalPaxOverrideOptions} from "../../../profile/user-profile-view-model.interface";
import {NullableNumber} from "../../../../../../types/nullable-types";

export class AgencyAuthorizedUserProfileDomainModel implements IAuthorizedUserProfileDomain {
    constructor(private readonly userProfile: AuthorizedUserProfileModel) {
        makeObservable<this, '_accountInfo'>(this, {
            _accountInfo: observable.ref
        });
    }

    get services(): IServiceFactory {
        return this.userProfile.services;
    }

    readonly canAddCompanions: boolean = false;
    readonly shouldLoadBookingHistoryOnStartup: boolean = false;
    readonly allowHoldBooking: boolean = true;

    async updateOrganizationInfo(): Promise<void> {

        try {
            const session = await this.userProfile.getSession();
            const response = await session.getAccountInfo(this.userProfile.organizationCode);
            if(response.hasErrors) {
                if(response.status !== HttpStatusCodeEnum.NotFound) {
                    this.services.logger.error('Failed to load user account info', `StatusCode: ${response.status}`, response.errors);
                }
            } else {
                runInAction(() => {
                    this._accountInfo = response.data;
                });
            }

        } catch (err) {
            this.services.logger.error('Failed to load user account info', err);
        }
    }

    async readCompanions(): Promise<CompanionModel[]> {
        return [];
    }
    async getBlueBenefitsSubscriptions(personComments: IDotRezPersonComment[]): Promise<IBlueBenefitsSubscription[]> {
        return [];
    }
    getCompanionsForBooking(): IPersonViewModel[] {
        return [];
    }
    async showContactInformationEditor(): Promise<DialogResult> {
        return await this.services.dialogFactory.showAgencyContactInformationEditor(this.userProfile);
    }

    private _accountInfo: IDotRezUserAccountInfo | null = null;
    get organizationCredit(): Price | null {
        if(this._accountInfo) {
            return this.services.currency.createPrice(this._accountInfo.totalAvailable, this._accountInfo.currencyCode);
        }

        return this.services.currency.createPrice(0, this.services.currency.current);
    }

    getPsoTotalPaxOverride(options: PsoTotalPaxOverrideOptions): NullableNumber {
        return options.psoMarket.getTotalPaxOverride(this.userProfile.organizationCode, options.departureDate);
    }


}